<template>
  <div v-if="weather" class="mt-5 bg-gradient-to-br from-sky-50 to-blue-50 border border-sky-100 rounded-xl p-5">
    <!-- Header -->
    <div class="flex items-start justify-between mb-4">
      <div>
        <h3 class="text-sm font-bold text-slate-800">{{ weather.city }}, {{ weather.country }}</h3>
        <p class="text-xs text-slate-500 mt-0.5">Current conditions</p>
      </div>
      <span class="text-3xl leading-none">{{ weatherEmoji }}</span>
    </div>

    <!-- Temperature -->
    <div class="flex items-end gap-3 mb-4">
      <span class="text-4xl font-bold text-slate-800 leading-none">{{ weather.temperatureC }}°C</span>
      <span class="text-sm text-slate-600 mb-1">{{ weather.condition }}</span>
    </div>

    <!-- Stats -->
    <div class="flex items-center gap-4 text-xs text-slate-500">
      <span class="flex items-center gap-1">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"/>
        </svg>
        Humidity {{ weather.humidity }}%
      </span>
      <span class="flex items-center gap-1">
        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3"/>
        </svg>
        Wind {{ Number(weather.windKph).toFixed(1) }} km/h
      </span>
    </div>

    <!-- Forecast -->
    <div v-if="weather.forecast && weather.forecast.length" class="mt-4">
      <p class="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Forecast</p>
      <div class="grid grid-cols-3 gap-2">
        <div
          v-for="day in weather.forecast"
          :key="day.date"
          class="bg-white rounded-lg p-2.5 text-center"
        >
          <p class="text-xs font-medium text-slate-500 mb-1">{{ day.date }}</p>
          <p class="text-base mb-1">{{ conditionEmoji(day.condition) }}</p>
          <p class="text-xs text-slate-600 font-medium">{{ day.minTempC }}°–{{ day.maxTempC }}°</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
function emojiFor(condition) {
  if (!condition) return '🌤️'
  const c = condition.toLowerCase()
  if (c.includes('thunder') || c.includes('storm'))              return '⛈️'
  if (c.includes('snow') || c.includes('blizzard') || c.includes('sleet')) return '❄️'
  if (c.includes('rain') || c.includes('drizzle') || c.includes('shower')) return '🌧️'
  if (c.includes('fog') || c.includes('mist') || c.includes('haze'))       return '🌫️'
  if (c.includes('overcast'))                                    return '☁️'
  if (c.includes('cloud') || c.includes('partly'))               return '⛅'
  if (c.includes('sun') || c.includes('clear') || c.includes('sunny'))     return '☀️'
  return '🌤️'
}

export default {
  name: "WeatherCard",
  props: {
    weather: { type: Object, default: null },
  },
  computed: {
    weatherEmoji() { return emojiFor(this.weather?.condition) },
  },
  methods: {
    conditionEmoji(condition) { return emojiFor(condition) },
  },
};
</script>
